import React, { useEffect, useState } from 'react';
import { makeStyles } from '@fluentui/react-components';
import { getExamsByLanguage } from '../../services/apiService';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { useAuth } from '../../contexts/AuthContext';
import { 
  Card,
  Text,
  Title1,
  Button,
  Badge,
} from '@fluentui/react-components';
import { 
  FaChevronRight, 
  FaPencilAlt,
  FaClock,
  FaQuestionCircle,
} from 'react-icons/fa';

const useStyles = makeStyles({
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '32px 24px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
  },
  headerIcon: {
    fontSize: '48px',
    color: '#0078d4',
    marginBottom: '16px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '600',
    color: '#323130',
    margin: 0,
  },
  subtitle: {
    fontSize: '16px',
    color: '#605e5c',
    maxWidth: '600px',
    textAlign: 'center',
  },
  examGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
    gap: '24px',
  },
  examCard: {
    padding: '24px',
    backgroundColor: '#fff',
    border: '1px solid #edebe9',
    borderRadius: '4px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
      borderColor: '#0078d4',
    },
  },
  examTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#323130',
    margin: 0,
  },
  examInfo: {
    display: 'flex',
    gap: '16px',
    marginTop: '8px',
  },
  infoItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: '#605e5c',
    fontSize: '14px',
  },
  infoIcon: {
    fontSize: '14px',
    color: '#0078d4',
  },
  examFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '16px',
    borderTop: '1px solid #edebe9',
    paddingTop: '16px',
  },
  startButton: {
    backgroundColor: '#0078d4',
    color: '#fff',
    padding: '8px 16px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: '500',
    '&:hover': {
      backgroundColor: '#106ebe',
    },
  },
  chevronIcon: {
    fontSize: '14px',
  },
  badge: {
    backgroundColor: '#e8f4fb',
    color: '#0078d4',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: '500',
  },
});

export default function Exams() {
  const styles = useStyles();
  const { categoryId } = useParams();
  const { user } = useAuth();
  const { t } = useTranslation(['dashboard']);
  const [exams, setExams] = useState([]);

  useEffect(() => {
    document.title = t('headers:exams');
  }, []);

  useEffect(() => {
    fetchExams();
  }, [i18next.language]);

  const fetchExams = async () => {
    const exams = await getExamsByLanguage(i18next.language, user.moduleId, categoryId);
    setExams(exams);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FaPencilAlt className={styles.headerIcon} />
        <Title1 className={styles.title}>{t('dashboard:exam-list')}</Title1>
        <Text className={styles.subtitle}>
          Aşağıdaki sınavlardan birini seçerek test çözmeye başlayabilirsiniz.
        </Text>
      </div>

      <div className={styles.examGrid}>
        {exams.map((exam) => (
          <Link 
            key={exam.id} 
            to={`/questions/${exam.id}`} 
            style={{ textDecoration: 'none' }}
          >
            <Card className={styles.examCard}>
              <div>
                <Text className={styles.examTitle}>
                  {exam.name}
                </Text>
                <div className={styles.examInfo}>
                  <span className={styles.infoItem}>
                    <FaQuestionCircle className={styles.infoIcon} />
                    {exam.questionCount} Soru
                  </span>
                  <span className={styles.infoItem}>
                    <FaClock className={styles.infoIcon} />
                    60 Dakika
                  </span>
                </div>
              </div>
              <div className={styles.examFooter}>
                <Badge appearance="outline" className={styles.badge}>
                  Deneme Sınavı
                </Badge>
                <Button 
                  className={styles.startButton}
                  appearance="primary"
                >
                  Sınava Başla
                  <FaChevronRight className={styles.chevronIcon} />
                </Button>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
